import { AlertTriangle } from 'lucide-react';
import { Modal } from './Modal';

interface Props {
  abierto: boolean;
  alCerrar: () => void;
  alConfirmar: () => void;
  eliminando: boolean;
  titulo: string;
  descripcion: string;

  detalle?: string | undefined;
  error?: string | null | undefined;
}

export function ConfirmarEliminacion({
  abierto,
  alCerrar,
  alConfirmar,
  eliminando,
  titulo,
  descripcion,
  detalle,
  error,
}: Props) {
  return (
    <Modal abierto={abierto} alCerrar={alCerrar} titulo={titulo} ancho="estrecho">
      <div className="flex gap-4">
        <span className="grid size-11 shrink-0 place-items-center rounded-full bg-red-50 text-alerta">
          <AlertTriangle className="size-5" aria-hidden />
        </span>
        <div className="min-w-0">
          <p className="text-sm text-armazon-700">{descripcion}</p>
          {detalle && (
            <p className="mt-2 truncate rounded-lg bg-armazon-50 px-3 py-2 text-sm font-semibold text-armazon-900">
              {detalle}
            </p>
          )}
          <p className="mt-3 text-xs text-armazon-500">Esta acción no se puede deshacer.</p>
        </div>
      </div>

      {error && (
        <p
          role="alert"
          className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-900"
        >
          {error}
        </p>
      )}

      <div className="mt-6 flex items-center justify-end gap-2 border-t border-armazon-100 pt-5">
        <button
          type="button"
          onClick={alCerrar}
          className="rounded-lg px-4 py-2 text-sm font-medium text-armazon-600 transition-colors hover:bg-armazon-100"
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={alConfirmar}
          disabled={eliminando}
          className="rounded-lg bg-alerta px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {eliminando ? 'Eliminando…' : 'Eliminar'}
        </button>
      </div>
    </Modal>
  );
}
